var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OfflineData } from '@tencent/ark-model';
import { StorageManager, DBEngineType, DB_NAME_BACKUP, OfflineDataStorage, } from '@tencent/ark-storage';
import { isSupportClientDB } from '../tools/utils';
import Log from '../tools/Log';
/**
 * 离线编辑备份模块
 *
 * @implements {OfflineEditBackUp<T>}
 * @template T
 */
var OfflineEditBackUp = /** @class */ (function () {
    function OfflineEditBackUp() {
        this.tag = 'OfflineEditBackUp';
    }
    OfflineEditBackUp.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var option, isSuccess;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        option = {
                            databaseName: DB_NAME_BACKUP,
                            type: isSupportClientDB() ? DBEngineType.nativeDB : DBEngineType.indexDB,
                        };
                        this.storageManager = new StorageManager(option);
                        return [4 /*yield*/, this.storageManager.init()];
                    case 1:
                        isSuccess = _a.sent();
                        this.isStorageAvailable = isSuccess;
                        if (!isSuccess) {
                            Log.error(this.tag, 'init error. open database fail');
                            return [2 /*return*/, false];
                        }
                        Log.info(this.tag, "init finish. isStorageAvailable:" + this.isStorageAvailable);
                        return [2 /*return*/, true];
                }
            });
        });
    };
    /**
     * 页面退出时需要销毁
     *
     */
    OfflineEditBackUp.prototype.dispose = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // 数据库断链
                this.storageManager.dispose();
                return [2 /*return*/, true];
            });
        });
    };
    OfflineEditBackUp.prototype.upsertChanges = function (changes) {
        return __awaiter(this, void 0, void 0, function () {
            var changeStorage, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isDatabaseAvailable()];
                    case 1:
                        if (!(_a.sent())) {
                            Log.warn(this.tag, 'upsertChanges can not write.');
                            return [2 /*return*/, false];
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        changeStorage = new OfflineDataStorage(this.storageManager.storage.collection(OfflineData));
                        return [4 /*yield*/, changeStorage.upsertChanges(changes)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 4:
                        error_1 = _a.sent();
                        Log.error(this.tag, "upsertChanges error: " + error_1.message + ", , " + error_1.stack + ".");
                        this.isStorageAvailable = false;
                        return [2 /*return*/, false];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    OfflineEditBackUp.prototype.isDatabaseAvailable = function () {
        return this.isStorageAvailable;
    };
    return OfflineEditBackUp;
}());
export { OfflineEditBackUp };
//# sourceMappingURL=oflfine-edit-backup.js.map